import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowRight } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { localizeApiError } from "@/i18n/apiErrors";

const MealPillLogo = () => (
  <svg width="72" height="72" viewBox="0 0 1024 1024" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ borderRadius: "18px" }}>
    <g clipPath="url(#mp_clip)">
      <path d="M233.095 0H801.74L800.928 1.21607C803.077 3.12413 833.417 10.6975 838.215 12.1038C843.831 13.7825 849.392 15.6384 854.89 17.6686C890.886 30.9237 924.302 54.677 950.6 82.3967C969.384 102.524 985.042 125.355 997.05 150.129C1003.94 164.39 1009.64 179.19 1014.12 194.381C1016.06 201.043 1019.72 220.027 1024 224.236V801.12C1021.03 802.687 1021.08 802.344 1020.03 805.838C1017.82 813.251 1016.32 820.852 1014.37 828.351C1011.93 837.393 1009.05 846.309 1005.73 855.065C975.066 936.796 907.82 993.395 824.009 1015.45C818.405 1016.93 802.65 1019.54 799.929 1024H226.12C222.746 1019.68 204.859 1016.68 198.938 1015.18C105.523 991.575 29.4598 914.931 7.64578 820.926C5.83191 813.11 3.88211 795.579 0 789.618V229.627C1.33871 228.542 2.34338 226.881 2.7286 225.206C6.13216 210.404 9.0872 196.445 13.873 181.974C39.0193 105.459 97.6419 44.5586 173.144 16.5159C183.181 12.6507 193.485 9.51715 203.975 7.1399C210.692 5.56444 227.753 2.87446 233.095 0Z" fill="#AAD3B7"/>
      <path d="M526.147 495.952C508.421 450.713 496.69 393.763 520.904 348.68C533.68 324.891 555.02 304.833 574.011 285.866L615.596 244.365C635.643 224.311 655.086 203.499 675.48 183.932C677.762 181.991 680.026 179.829 682.326 177.634L682.339 177.622C691.453 168.923 701.117 159.7 714.571 161.5C739.14 164.787 744.594 179.949 742.779 201.115C738.135 210.305 735.506 214.427 728.856 222.269C701.674 247.262 675.717 273.803 650.174 300.461C633.674 317.679 610.829 332.85 604.498 356.761C609.81 367.937 613.101 375.771 624.893 381.014C629.646 380.955 633.199 380.581 637.529 378.525C656.669 369.434 687.876 333.657 703.97 317.16C706.605 314.459 710.354 310.405 714.865 305.526L714.909 305.479L714.916 305.471C737.494 281.054 779.104 236.055 796.076 236.09C803.459 236.105 813.755 242.206 818.706 247.482C824.141 253.276 827.191 259.93 828.854 267.621C824.273 282.654 808.776 302.149 797.798 313.225C772.692 338.555 746.249 362.589 721.62 388.501C710.298 400.413 696.816 411.148 688.565 425.66C681.72 437.184 687.576 453.611 700.205 457.921C708.89 461.015 719.653 457.548 727.61 452.224C744.886 440.665 757.34 422.721 772.611 408.783C794.276 388.021 812.655 364.828 834.798 344.652C835.394 344.11 835.997 343.559 836.608 343C848.46 332.162 863.195 318.689 880.256 323.177C894.711 326.979 899.779 339.614 903.5 352.51C889.876 382.575 873.63 395.657 850.911 418.302C832.269 436.85 813.852 455.625 795.667 474.624C788.08 481.887 777.666 493.124 771.137 499.721C734.862 536.38 710.057 561.447 642.723 560.236C623.22 559.886 593.92 556.4 575.005 552.17C524.274 617.032 480.37 678.564 449.271 755.523C443.742 769.036 438.772 782.771 434.373 796.691C428.676 815.119 423.77 835.031 415.135 852.076C407.543 866.671 382.759 871.492 370.318 860.502C353.855 845.968 350.39 821.061 341.432 801.875C299.743 712.587 238.499 630.354 161.199 568.82C141.487 553.129 121.181 550.498 118.482 520.84C118.341 519.253 118.241 517.662 118.184 516.07C121.385 511.933 124.557 507.747 127.899 503.723C132.738 497.898 138.639 492.892 146.52 492.361C180.557 490.067 296.74 599.311 324.462 627.495C339.211 642.489 350.956 660.286 366.986 674.093C372.443 678.792 378.303 682.973 385.891 682.175C392.775 681.45 398.551 676.457 402.757 671.258C410.804 661.313 417.018 649.429 423.449 638.42C429.981 627.151 436.914 616.119 444.232 605.347C469.298 568.152 498.591 531.417 526.147 495.952Z" fill="#FEB08C"/>
    </g>
    <defs>
      <clipPath id="mp_clip"><rect width="1024" height="1024" fill="white"/></clipPath>
    </defs>
  </svg>
);

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        setError(localizeApiError(data.detail, t));
        return;
      }
      setSent(true);
    } catch (err) {
      setError(t("errNetwork"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md text-center mb-8">
        <div className="flex justify-center mb-6">
          <MealPillLogo />
        </div>
        <h1 className="font-heading text-4xl text-[#3D4035] mb-2">Meal Pill</h1>
        <p className="font-body text-[#6B705C] text-lg">
          {sent ? (t("checkYourEmail") || "Check your email") : (t("resetYourPassword") || "Reset your password")}
        </p>
      </div>

      <div className="w-full max-w-md bg-white rounded-3xl shadow-[0_8px_30px_rgb(0,0,0,0.04)] p-8 border border-black/5">
        {!sent ? (
          <>
            <p className="font-body text-[#6B705C] mb-6 text-center leading-relaxed">
              {t("forgotPasswordDesc") || "Enter your email and we'll send you a link to reset your password."}
            </p>
            <form onSubmit={handleSubmit} className="space-y-5">
              <div className="relative">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#A5A58D]" strokeWidth={1.5} />
                <input
                  type="email"
                  autoComplete="email"
                  autoFocus
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder={t("email") || "Email"}
                  className="w-full bg-white border-transparent ring-1 ring-[#E8E5E0] focus:ring-2 focus:ring-[#7B9E7F]/50 rounded-xl h-14 pl-12 pr-4 font-body text-[#3D4035] placeholder:text-[#A5A58D] outline-none transition-all"
                />
              </div>
              {error && (
                <div className="text-[#BC4749] text-sm font-body bg-[#BC4749]/10 rounded-xl px-4 py-3">
                  {error}
                </div>
              )}
              <button
                type="submit"
                disabled={loading || !email.trim()}
                className="w-full bg-[#7B9E7F] text-white rounded-full h-14 font-body font-bold text-lg hover:opacity-90 transition-all active:scale-[0.98] shadow-lg shadow-[#7B9E7F]/20 flex items-center justify-center gap-2 disabled:opacity-50"
              >
                {loading ? (
                  <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                ) : (
                  <>
                    {t("sendResetLink") || "Send reset link"}
                    <ArrowRight className="w-5 h-5" strokeWidth={1.5} />
                  </>
                )}
              </button>
            </form>
            <div className="mt-6 text-center">
              <Link to="/" className="font-body text-[#6B705C] hover:text-[#7B9E7F] transition-colors text-sm">
                ← {t("backToSignIn") || "Back to sign in"}
              </Link>
            </div>
          </>
        ) : (
          <div className="text-center py-4">
            <div className="w-16 h-16 bg-[#7B9E7F]/10 rounded-full flex items-center justify-center mx-auto mb-6">
              <Mail className="w-7 h-7 text-[#7B9E7F]" strokeWidth={1.5} />
            </div>
            <p className="text-[#6B705C] font-body leading-relaxed mb-2">
              {t("resetLinkSent") || "If an account exists for that email, we've sent a reset link."}
            </p>
            <p className="text-sm font-body text-[#A5A58D] mb-8">
              {t("checkSpam") || "Didn't receive it? Check your spam folder."}
            </p>
            <Link
              to="/"
              className="inline-block bg-[#7B9E7F] text-white px-8 py-3 rounded-full font-body font-bold hover:opacity-90 transition-all active:scale-[0.98] shadow-lg shadow-[#7B9E7F]/20"
            >
              {t("backToSignIn") || "Back to sign in"}
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}